import {
  ToggleButton as MuiToggleButton,
  type ToggleButtonProps as MuiToggleButtonProps,
} from '@mui/material';

export type ToggleButtonProps = MuiToggleButtonProps;

export const ToggleButton = (props: ToggleButtonProps) => (
  <MuiToggleButton data-testid="toggleButton" {...props} />
);
